import savingsActionTypes from './savings.types';

/** ***************** ADD SAVINGS DETAILS START *********************** */
export const addSavingsDetailsStart = (addData: any) => ({
	type: savingsActionTypes.ADD_SAVINGS_DETAILS_START,
	payload: addData,
});

export const addSavingsDetailsSuccess = (successData: any) => ({
	type: savingsActionTypes.ADD_SAVINGS_DETAILS_SUCCESS,
	payload: successData,
});

export const addSavingsDetailsFailure = (failureData: any) => ({
	type: savingsActionTypes.ADD_SAVINGS_DETAILS_FAILURE,
	payload: failureData,
});

export const addSavingsDetailsResponseResetStart = () => ({
	type: savingsActionTypes.ADD_SAVINGS_DETAILS_RESPONSE_RESET,
});

export const addSavingsDetailsResponseChanged = () => ({
	type: savingsActionTypes.ADD_SAVINGS_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD SAVINGS DETAILS END *********************** */

/** ***************** UPDATE SAVINGS DETAILS START *********************** */
export const updateSavingsDetailsStart = (updateData: any) => ({
	type: savingsActionTypes.UPDATE_SAVINGS_DETAILS_START,
	payload: updateData,
});

export const updateSavingsDetailsSuccess = (successData: any) => ({
	type: savingsActionTypes.UPDATE_SAVINGS_DETAILS_SUCCESS,
	payload: successData,
});

export const updateSavingsDetailsFailure = (failureData: any) => ({
	type: savingsActionTypes.UPDATE_SAVINGS_DETAILS_FAILURE,
	payload: failureData,
});

export const updateSavingsDetailsResponseResetStart = () => ({
	type: savingsActionTypes.UPDATE_SAVINGS_DETAILS_RESPONSE_RESET,
});

export const updateSavingsDetailsResponseChanged = () => ({
	type: savingsActionTypes.UPDATE_SAVINGS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE SAVINGS DETAILS END *********************** */

/** ***************** GET SAVINGS LIST START *********************** */
export const getSavingsListStart = (getData: any) => ({
	type: savingsActionTypes.GET_SAVINGS_LIST_START,
	payload: getData,
});

export const getSavingsListSuccess = (successData: any) => ({
	type: savingsActionTypes.GET_SAVINGS_LIST_SUCCESS,
	payload: successData,
});

export const getSavingsListFailure = (failureData: any) => ({
	type: savingsActionTypes.GET_SAVINGS_LIST_FAILURE,
	payload: failureData,
});

export const getSavingsListResponseResetStart = () => ({
	type: savingsActionTypes.GET_SAVINGS_LIST_RESPONSE_RESET,
});

export const getSavingsListResponseChanged = () => ({
	type: savingsActionTypes.GET_SAVINGS_LIST_RESPONSE_CHANGED,
});
/** ***************** GET SAVINGS LIST END *********************** */

/** ***************** FETCH SAVINGS DETAILS START *********************** */
export const fetchSavingsDetailsStart = (fetchData: any) => ({
	type: savingsActionTypes.FETCH_SAVINGS_DETAILS_START,
	payload: fetchData,
});

export const fetchSavingsDetailsSuccess = (successData: any) => ({
	type: savingsActionTypes.FETCH_SAVINGS_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchSavingsDetailsFailure = (failureData: any) => ({
	type: savingsActionTypes.FETCH_SAVINGS_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchSavingsDetailsResponseResetStart = () => ({
	type: savingsActionTypes.FETCH_SAVINGS_DETAILS_RESPONSE_RESET,
});

export const fetchSavingsDetailsResponseChanged = () => ({
	type: savingsActionTypes.FETCH_SAVINGS_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH SAVINGS DETAILS END *********************** */

/** ***************** DELETE SAVINGS DETAILS START *********************** */
export const deleteSavingsDetailsStart = (deleteData: any) => ({
	type: savingsActionTypes.DELETE_SAVINGS_DETAILS_START,
	payload: deleteData,
});

export const deleteSavingsDetailsSuccess = (successData: any) => ({
	type: savingsActionTypes.DELETE_SAVINGS_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteSavingsDetailsFailure = (failureData: any) => ({
	type: savingsActionTypes.DELETE_SAVINGS_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteSavingsDetailsResponseResetStart = () => ({
	type: savingsActionTypes.DELETE_SAVINGS_DETAILS_RESPONSE_RESET,
});

export const deleteSavingsDetailsResponseChanged = () => ({
	type: savingsActionTypes.DELETE_SAVINGS_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE SAVINGS DETAILS END *********************** */

/** ***************** FETCH ALL SAVINGS LIST START *********************** */
export const fetchAllSavingsListStart = (fetchAllData: any) => ({
	type: savingsActionTypes.FETCH_ALL_SAVINGS_START,
	payload: fetchAllData,
});

export const fetchAllSavingsListSuccess = (successData: any) => ({
	type: savingsActionTypes.FETCH_ALL_SAVINGS_SUCCESS,
	payload: successData,
});

export const fetchAllSavingsListFailure = (failureData: any) => ({
	type: savingsActionTypes.FETCH_ALL_SAVINGS_FAILURE,
	payload: failureData,
});

export const fetchAllSavingsListResponseResetStart = () => ({
	type: savingsActionTypes.FETCH_ALL_SAVINGS_RESPONSE_RESET,
});

export const fetchAllSavingsListResponseChanged = () => ({
	type: savingsActionTypes.FETCH_ALL_SAVINGS_RESPONSE_CHANGED,
});
/** ***************** FETCH ALL SAVINGS LIST END *********************** */
